// app/studente/studenteDetail.js

(function () {
    'use strict';
    var controllerId = 'dashboard_Super';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', '_', '$scope', '$filter', '$routeParams', 'datacontext', 'sectionMenu', '$uibModal', dashboard_Super]);

    function dashboard_Super($rootScope, common, _, $scope, $filter, $routeParams, datacontext, sectionMenu, $uibModal) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = " dashview";
        var vm = this;
        vm.title = 'Supervisore';
        vm.sectionMenu = sectionMenu.setSection('');

        //filter per Anno: default l'anno corrente        
        vm.filter = {};
        if ($rootScope.annoScolastico == 0)
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        else
            vm.fAnno = $rootScope.annoScolastico;
        vm.filter.anno = vm.fAnno;

        vm.getAll = getAllFunc;

        vm.dashboard = {};
        vm.dashboard.numClassi = 0;
        vm.dashboard.numRisorse = 0;
        vm.dashboard.numStudenti = 0;
        vm.dashboard.numCommerciali = 0;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getDashboard(), $rootScope.getWhoAmI()]; // $rootScope.getWhoAmI() aggiungto per problema cookie
            common.activateController(promises, controllerId)
                    .then(function () { });
        }

        //****************************************************
        // METODI 
        //****************************************************

        function getAllFunc() {
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            $rootScope.annoScolastico = vm.filter.anno;

            getDashboard();
        }

        function getDashboard() {
            datacontext.dashboard_get(vm.filter.anno).then(function (data) {
                vm.dashboard = data;
            });
        }
    }
})();